/**
 *
 * Asynchronously loads the component for RetailSignUp
 *
 */

import React from 'react'
import loadable from 'utils/loadable'
import { Loading } from 'components/Loading'

export default loadable({
  loader: () => import('./index' /* webpackChunkName: "RetailSignUp" */),
  loading: <Loading />
})
